'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/require-default-props */
var boolean = function boolean() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      props = _ref.props;

  var Boolean = function Boolean(_ref2) {
    var value = _ref2.value,
        onValue = _ref2.onValue;
    return _react2.default.createElement(
      'div',
      props,
      _react2.default.createElement(
        'button',
        {
          disabled: value,
          onClick: function onClick() {
            return onValue(true);
          }
        },
        '\u2713'
      ),
      _react2.default.createElement(
        'button',
        {
          disabled: !value,
          onClick: function onClick() {
            return onValue(false);
          }
        },
        '\u2717'
      )
    );
  };
  Boolean.propTypes = {
    value: _propTypes2.default.any,
    onValue: _propTypes2.default.func
  };

  return Boolean;
};

exports.default = boolean;